// extracted by mini-css-extract-plugin
export default {"menuCounter":"NavigationTabBarItems_menuCounter__M-o2l"};